import {gatherMin} from 'helpers/array-helper';
import Const from 'constants';
import {sortByProperty, sortByProperties} from 'helpers/sorters';
import $ from 'jquery';

let PositionInLineup = {
    set: {
        inDependenceOnPositionName: function (team, callBack = null) {
            team.map((player) => {
                player.positionInLineup = player.positionName;
                if (typeof callBack === 'function') {
                    callBack(player);
                }
            });
            return team;
        },
        inDependenceOnOrder: function (params) {
            const {team, positionsOrder, functions = {}} = params;
            const distributablePlayers = team.map((player) => ({player: {...player}, isTaken: false}));

            const result = [];
            try {
                Object.values(positionsOrder).map((position) => {
                    let isSuitablePlayerFound = false;

                    for (const distributablePlayer of distributablePlayers) {
                        if (distributablePlayer.isTaken) continue;

                        const player = distributablePlayer.player;

                        if ('canPlayerBeSetOnPositionFunctions' in functions) {
                            let shouldPlayerBeSkipped = false;
                            for (const canPlayerBeSetOnPosition of functions.canPlayerBeSetOnPositionFunctions) {
                                if (!canPlayerBeSetOnPosition(player, position)) {
                                    shouldPlayerBeSkipped = true;
                                    break;
                                }
                            }

                            if (shouldPlayerBeSkipped) continue;
                        }

                        for (let posNumber of position.allowedPositions) {
                            const playerPosition = Array.isArray(player.position) ? player.position : [player.position];

                            if (inArray(posNumber, playerPosition)) {
                                isSuitablePlayerFound = true;
                                if (!player.hasOwnProperty('positionIdInLineup')) {
                                    player.positionIdInLineup = position.id;
                                    player.positionInLineup = position.alias;
                                }

                                result.push(player);
                                distributablePlayer.isTaken = true;
                                break;
                            }
                        }

                        if (isSuitablePlayerFound) break;
                    }
                });
            } catch (e) {
                console.error(e);
            }

            if (distributablePlayers.some((distributablePlayer) => !distributablePlayer.isTaken)) {
                return [];
            }

            return [...result];
        },
        inDependenceOnDistribution: function (params) {
            const {team: incomingTeam, sportConfig, functions = {}} = params;

            const team = [...incomingTeam];
            const positionsOrder = Object.values(sportConfig.getConfigProp('positionsOrder', {}));
            const positionsConfig = sportConfig.getConfigProp('positions', {});

            const createMatrix = function (team, usedPositions, userPlayers) {
                const result = {players: {}, positions: {}};

                team.map((player) => {
                    const playerId = player.getId();

                    if (inArray(playerId, userPlayers)) {
                        return;
                    }

                    result.players[playerId] ??= {
                        positions: [],
                        positionAliases: [],
                        positionsQuantity: 0,
                        positionAliasesQuantity: 0,
                        entity: {...player},
                    };

                    positionsOrder.map((pos) => {
                        if (inArray(pos.id, usedPositions)) {
                            return;
                        }

                        if ('canPlayerBeSetOnPositionFunctions' in functions) {
                            for (const canPlayerBeSetOnPosition of functions.canPlayerBeSetOnPositionFunctions) {
                                if (!canPlayerBeSetOnPosition(player, pos)) {
                                    return;
                                }
                            }
                        }

                        result.positions[pos.id] ??= {players: [], quantity: 0};

                        for (const posNumber of pos.allowedPositions) {
                            const playerPositions = Array.isArray(player.position)
                                ? player.position
                                : [player.position];
                            if (!inArray(posNumber, playerPositions)) {
                                continue;
                            }

                            if (!inArray(pos.id, result.players[playerId].positions)) {
                                if ('positionIdInLineup' in player) {
                                    result.players[playerId].positions.push(player.positionIdInLineup);
                                } else {
                                    result.players[playerId].positions.push(pos.id);
                                }

                                result.players[playerId].positionsQuantity++;

                                if (!result.players[playerId].positionAliases.includes(pos.alias)) {
                                    result.players[playerId].positionAliases.push(pos.alias);
                                    result.players[playerId].positionAliasesQuantity++;
                                }
                            }

                            if (!inArray(playerId, result.positions[pos.id].players)) {
                                result.positions[pos.id].players.push(playerId);
                                result.positions[pos.id].quantity++;
                            }
                        }
                    });
                });

                return result;
            };

            const definePositionIdInLineup = function (player, positions) {
                let result, quantity;
                player.positions.map((pos) => {
                    if (!result || positions[pos].quantity < quantity) {
                        result = pos;
                        quantity = positions[pos].quantity;
                    }
                });

                return result;
            };

            const definePositionAlias = function (positionsOrder, positionId) {
                for (let pos of positionsOrder) {
                    if (pos.id === positionId) {
                        return pos.alias;
                    }
                }

                return '';
            };

            const definePositionNumber = function (player, positionsOrder) {
                let result;
                for (let pos of positionsOrder) {
                    if (pos.alias !== player.positionInLineup) {
                        continue;
                    }
                    const playerPositions = Array.isArray(player.position) ? player.position : [player.position];
                    let positions = arrayDuplicates(playerPositions, pos.allowedPositions);
                    result = positions[0];
                }

                return result;
            };

            const definePositionName = (player) => positionsConfig[player.position].shortName;

            const definePlayerToSetOnPosition = function (matrix) {
                if ('getPriorityPlayerToSetOnPositionIfExists' in functions) {
                    const priorityPlayer = functions.getPriorityPlayerToSetOnPositionIfExists(matrix);
                    if (!isEmpty(priorityPlayer)) {
                        return {...priorityPlayer};
                    }
                }

                const playersPool = Object.values(matrix.players);
                playersPool.sort(sortByProperties(['positionAliasesQuantity', 'positionsQuantity']));

                const positionsPool = Object.values(matrix.positions);
                positionsPool.sort(sortByProperty('quantity'));

                const {positionAliasesQuantity} = playersPool[0];
                const {quantity: playersQuantity} = positionsPool[0];

                let playerEntity = {};
                if (playersQuantity <= positionAliasesQuantity) {
                    const pool = gatherMin(positionsPool, 'quantity');
                    pool.map((item) => {
                        item.players.map((key) => {
                            const player = matrix.players[key];
                            if (
                                isEmpty(playerEntity) ||
                                playerEntity.positionAliasesQuantity > player.positionAliasesQuantity
                            ) {
                                playerEntity = {...player};
                            }
                        });
                    });
                } else {
                    const pool = gatherMin(playersPool, 'positionAliasesQuantity');
                    pool.map((item) => {
                        item.positions.map((key) => {
                            const position = matrix.positions[key];
                            if (isEmpty(playerEntity) || playerEntity.positionAliasesQuantity > position.quantity) {
                                playerEntity = {...item};
                            }
                        });
                    });
                }

                return {...playerEntity};
            };

            let result = [];
            try {
                let usedPositions = [];
                let usedPlayers = [];
                let lineup = [];

                for (let i in team) {
                    // console.log('----------------------------------- ' + (1 + Number(i)))
                    let matrix = createMatrix(team, usedPositions, usedPlayers);
                    // console.log('matrix',{...matrix});
                    let player = definePlayerToSetOnPosition(matrix);

                    let playerEntity = player.entity;
                    // console.log('player',{...player});
                    let positionId = definePositionIdInLineup(player, matrix.positions);
                    // console.log('positionId',positionId);
                    playerEntity.positionIdInLineup = positionId;
                    playerEntity.positionInLineup = definePositionAlias(positionsOrder, positionId);
                    // console.log('player.positionInLineup',playerEntity.positionInLineup);
                    playerEntity.position = definePositionNumber(playerEntity, positionsOrder);
                    // console.log('player.position',playerEntity.position);
                    playerEntity.positionName = definePositionName(playerEntity);
                    // console.log('player.positionName',playerEntity.positionName);
                    usedPositions.push(positionId);
                    usedPlayers.push(playerEntity.playerId);
                    lineup.push(playerEntity);
                    // console.log('----------------------------------- ' + (1 + Number(i)))
                }
                // console.log('lineup',{...lineup})
                positionsOrder.map((position) => {
                    for (let i in lineup) {
                        if (lineup[i].positionIdInLineup === position.id) {
                            result.push(lineup[i]);
                            delete lineup[i];
                            break;
                        }
                    }
                });
            } catch (e) {
                console.error(e);
            }
            // console.log('result', [...result]);
            return [...result];
        },
    },
};

function calcQuantityOfReservedLineupsByExposure(quantityLineups, exposure) {
    if (exposure > 0) {
        let result = (quantityLineups * exposure) / 100;
        return Math.floor(result);
    }
    return 0;
}

function countPlayerIdInLineups(playerIds, lineupsRow) {
    if (!Array.isArray(playerIds)) {
        playerIds = [playerIds];
    }

    let quantity = 0;
    playerIds.map((playerId) => {
        lineupsRow.split('+' + Const.LP_UNIT_PREFIX).map((lineupPlayerId) => {
            if (String(playerId) === lineupPlayerId) {
                quantity++;
            }
        });
    });

    return quantity;
}

function sortPlayersByLineupPositionId(players, positionsOrder) {
    if (isEmpty(positionsOrder) || isEmpty(players) || !players[0].positionIdInLineup) {
        return players;
    }

    const sortedPlayers = [];
    Object.values(positionsOrder).map((position) => {
        for (let player of players) {
            if (position.id === player.positionIdInLineup) {
                sortedPlayers.push(player);
                break;
            }
        }
    });

    return sortedPlayers;
}

function replaceLineupPlayer(searchPlayer, replacePlayer, lineupPlayers) {
    function changePlayers(prevPlayer, newPlayer) {
        const player = cp(newPlayer);

        player.positionInLineup = prevPlayer.positionInLineup;
        player.positionIdInLineup = prevPlayer.positionIdInLineup;
        player.boostedPoints = 0;
        // https://abnk.atlassian.net/browse/DFSA-626
        // player.position = prevPlayer.position;

        if ('lineupRole' in prevPlayer) {
            // Key sequence: lineupPoints based on lineupRole, so lineupRole must be assigned first.
            player.lineupRole = prevPlayer.lineupRole;
            player.lineupPoints = player.getPropValueOfLineupRole('userPoints');
        } else {
            player.lineupPoints = player.userPoints;
        }

        return player;
    }

    return lineupPlayers.map((player) => {
        if (player.playerId === searchPlayer.playerId) {
            return changePlayers(player, replacePlayer);
        }

        return player;
    });
}

function createViewComponentLineupId(lineupId) {
    return `lineup-${lineupId}`;
}

function scrollToLineup(lineupId) {
    const viewComponentLineupId = createViewComponentLineupId(lineupId);

    const lineupElement = $(`#${viewComponentLineupId}`);

    if (!lineupElement.length) {
        return;
    }

    const parent = lineupElement.parent();
    const scrollPosition = parent.scrollTop() + lineupElement.position().top;

    parent.scrollTop(scrollPosition);
}

function isLineupValid(simplexLineup, sportConfig) {
    if (sportConfig.isGameTypeTiers()) {
        return simplexLineup.hasUnits();
    }

    return simplexLineup.getUnits().length === sportConfig.getPlayersInTeam();
}

export {
    PositionInLineup,
    calcQuantityOfReservedLineupsByExposure,
    countPlayerIdInLineups,
    replaceLineupPlayer,
    sortPlayersByLineupPositionId,
    createViewComponentLineupId,
    scrollToLineup,
    isLineupValid,
};
